import { createClient } from '@base44/sdk';

// Login/Portal access uses our custom auth (independentLogin + localStorage 'jotunheims_user').
// Register/ForgotPassword/ResetPassword use Base44's own auth SDK (base44.auth.*) — both can coexist.
export const base44 = createClient({
  appId: import.meta.env.VITE_BASE44_APP_ID,
  functionsVersion: import.meta.env.VITE_BASE44_FUNCTIONS_VERSION,
  appBaseUrl: import.meta.env.VITE_BASE44_APP_BASE_URL,
  requiresAuth: false,
});